import React, { useCallback, useEffect } from "react";

import OverlayFreemium from "../OverlayFreemium";
import ChoosePlan from "../../../dialogs/Billing/ChoosePlan";
import { useAuth } from "../../../hooks/auth";
import { Company } from "../../../interfaces/Company";
import api from "../../../services/api";

interface FreemiumFeatureProps {
    children: React.ReactNode,
    isPaidFeature: boolean,
    title: string,
    description: string,
    buttonText?: string,
    planRequired: string,
    source: string,
    company?: Company,
    maxWidth?: number,
    style?: React.CSSProperties,
    handleUpgrade?: () => void
}

const linkWhatsapp = "https://api.whatsapp.com/send?phone=551151989897";

const FreemiumFeature: React.FC<FreemiumFeatureProps> = ({ isPaidFeature, children, title, description, buttonText, company, planRequired, maxWidth, handleUpgrade, style, source }) => {

    const { renewUser } = useAuth();
    const [openBilling, setOpenBilling] = React.useState(false);
    const [currentPlan, setCurrentPlan] = React.useState<string | undefined>(undefined);
    const [ctaText, setCtaText] = React.useState<string | undefined>(undefined);

    const handleLogClickApi = useCallback(async () => {

        await api.post('/log-history', {
            log_type_id: 58,
            change_type: 'C',
            description: `User clicked on upgrade button`,
            key: source,
            new_value: buttonText,
        })

    }, [source, buttonText]);

    const goToContactPage = useCallback(() => {

        window.open(linkWhatsapp, "_blank");

    }, []);

    const handleCustomUpgrade = () => {

        handleLogClickApi();

        if (handleUpgrade !== undefined) { //If the handleUpgrade is defined, use it
            handleUpgrade();
        } else if (currentPlan === "Plus" && (planRequired === "Professional" || planRequired === "Enterprise")) { //If the current plan is Plus and the required plan is Professional or Enterprise, go to the contact page
            goToContactPage();
        } else if (planRequired === "Enterprise") { //If the required plan is Enterprise, go to the contact page
            goToContactPage();
        } else { //If the current plan is not Plus and the required plan is not Enterprise, open the billing modal
            setOpenBilling(true);
        }

    };

    useEffect(() => {
        if (company !== undefined && company.company_plan !== undefined) {
            if (company.company_plan.length > 0) {
                setCurrentPlan(company.company_plan[0].plan.name);
            } else {
                setCurrentPlan(undefined);
            }
        }
    }, [company]);

    useEffect(() => {
        if (buttonText !== undefined) {
            setCtaText(buttonText);
        } else {
            if (currentPlan === undefined) {
                setCtaText("Fazer upgrade");
            } else if (currentPlan === "Plus" && (planRequired === "Professional" || planRequired === "Enterprise")) {
                setCtaText("Solicitar upgrade");
            }
        }
    }, [buttonText, currentPlan, planRequired]);

    return (
        <div style={{ position: 'relative', ...style }} className="freemium-feature">
            {isPaidFeature && (
                <OverlayFreemium
                    title={title}
                    description={description}
                    buttonText={ctaText !== undefined ? ctaText : "Fazer upgrade"}
                    planRequired={planRequired}
                    maxWidth={maxWidth}
                    onUpgrade={handleCustomUpgrade}
                />)
            }
            {children}

            <ChoosePlan
                open={openBilling}
                onClose={() => {
                    renewUser();
                    setOpenBilling(false);
                }}
                isEndTrial={false}
            />
        </div>
    );

}

export default FreemiumFeature;